import { render, staticRenderFns } from "./ExportBoards.vue?vue&type=template&id=071eecb6&scoped=true"
import script from "./ExportBoards.vue?vue&type=script&lang=js"
export * from "./ExportBoards.vue?vue&type=script&lang=js"
import style0 from "./ExportBoards.vue?vue&type=style&index=0&id=071eecb6&prod&lang=scss&scoped=true"
import style1 from "./ExportBoards.vue?vue&type=style&index=1&id=071eecb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071eecb6",
  null
  
)

export default component.exports